import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "src/app/app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class NewsalesandvolumeService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getSalesAndVolumeZeroData(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.ALL_SALES_VOLUME.SALES_VOLUME_ZERO_DATA}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
